import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDSnackbar from "components/MDSnackbar";

import { RequestService } from "services/RequestService";

function BasicInfo() {
  const [userProfile, setUserProfile] = useState({
    displayName: "",
    email: "",
    userName: "",
    userTypeName: "",
    lastPasswordChangedDate: "",
    isEnabled: false,
    createDate: "",
  });

  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const handleCloseNotification = () => {
    setNotification({ ...notification, show: false });
  };

  const fetchUserProfile = async () => {
    try {
      const response = await RequestService.get("Auth/my-profile");
      if (response.data && !response.data.error) {
        const { data } = response.data;
        setUserProfile({
          displayName: data.displayName || "",
          email: data.email || "",
          userName: data.userName || "",
          userTypeName: data.userTypeName || "",
          lastPasswordChangedDate: data.lastPasswordChangedDate ? 
            new Date(data.lastPasswordChangedDate).toLocaleDateString('ar-IQ') : "",
          isEnabled: data.isEnabled,
          createDate: data.createdAt ? 
            new Date(data.createdAt).toLocaleDateString('ar-IQ') : "",
        });
      } else {
        setNotification({
          show: true,
          message: "حدث خطأ أثناء جلب البيانات",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      setNotification({
        show: true,
        message: "حدث خطأ أثناء جلب البيانات",
        type: "error",
      });
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <Card id="basic-info" sx={{ overflow: "visible", boxShadow: "none", border: "1px solid #eee" }}>
      <MDBox p={3}>
        <MDBox mb={3}>
          <MDTypography variant="h5" fontWeight="bold" color="dark">
            المعلومات الأساسية
          </MDTypography>
          <MDTypography variant="button" color="text">
            معلومات الملف الشخصي الخاص بك
          </MDTypography>
        </MDBox>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <MDInput
              fullWidth
              label="الاسم المعروض"
              value={userProfile.displayName}
              disabled
              sx={{
                "& .MuiInputBase-root": {
                  height: "44px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  "&.Mui-disabled": {
                    backgroundColor: "#f8f9fa",
                  }
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#344767",
                },
                "& .MuiInputLabel-root": {
                  color: "#344767",
                  opacity: 0.8,
                },
                mb: 3
              }}
            />
            <MDInput
              fullWidth
              label="البريد الإلكتروني"
              value={userProfile.email}
              disabled
              sx={{
                "& .MuiInputBase-root": {
                  height: "44px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  "&.Mui-disabled": {
                    backgroundColor: "#f8f9fa",
                  }
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#344767",
                },
                "& .MuiInputLabel-root": {
                  color: "#344767",
                  opacity: 0.8,
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDInput
              fullWidth
              label="اسم المستخدم"
              value={userProfile.userName}
              disabled
              sx={{
                "& .MuiInputBase-root": {
                  height: "44px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  "&.Mui-disabled": {
                    backgroundColor: "#f8f9fa",
                  }
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#344767",
                },
                "& .MuiInputLabel-root": {
                  color: "#344767",
                  opacity: 0.8,
                },
                mb: 3
              }}
            />
            <MDInput
              fullWidth
              label="نوع المستخدم"
              value={userProfile.userTypeName}
              disabled
              sx={{
                "& .MuiInputBase-root": {
                  height: "44px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  "&.Mui-disabled": {
                    backgroundColor: "#f8f9fa",
                  }
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#344767",
                },
                "& .MuiInputLabel-root": {
                  color: "#344767",
                  opacity: 0.8,
                }
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <MDBox 
              sx={{ 
                borderTop: "1px solid #eee",
                pt: 3,
                mt: 2
              }}
            >
              <MDTypography variant="button" color="text" fontWeight="medium" mb={2} display="block">
                معلومات إضافية
              </MDTypography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      p: 2,
                      height: "100%",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <Icon sx={{ color: "#344767", marginLeft: 2 }}>calendar_today</Icon>
                    <MDBox>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        تاريخ الإنشاء
                      </MDTypography>
                      <MDTypography variant="button" color="dark" fontWeight="regular" display="block">
                        {userProfile.createDate}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      p: 2,
                      height: "100%",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <Icon sx={{ color: "#344767", marginLeft: 2 }}>lock_clock</Icon>
                    <MDBox>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        آخر تغيير لكلمة المرور
                      </MDTypography>
                      <MDTypography variant="button" color="dark" fontWeight="regular" display="block">
                        {userProfile.lastPasswordChangedDate}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      p: 2,
                      height: "100%",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <Icon sx={{ 
                      color: userProfile.isEnabled ? "#66BB6A" : "#f44335",
                      marginLeft: 2 
                    }}>
                      {userProfile.isEnabled ? "check_circle" : "cancel"}
                    </Icon>
                    <MDBox>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        حالة الحساب
                      </MDTypography>
                      <MDTypography 
                        variant="button" 
                        color={userProfile.isEnabled ? "success" : "error"}
                        fontWeight="medium" 
                        display="block"
                      >
                        {userProfile.isEnabled ? "مفعل" : "معطل"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <MDSnackbar
        color={notification.type}
        icon="warning"
        title="لوحة ادارة ربان السفينة"
        content={notification.message}
        open={notification.show}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </Card>
  );
}

export default BasicInfo;
